"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultHttpClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const auth_client_1 = require("../auth.client");
const sdk_contants_1 = require("../../../constants/sdk.contants");
class DefaultHttpClient extends dp_http_client_lib_1.DefaultHttpClient {
    constructor(options) {
        super(options);
        if (options && options.clientId) {
            this.tokenRequest = {
                clientId: options.clientId,
                clientSecret: options.clientSecret,
                scope: options.scope,
                type: options.type,
            };
        }
        this.authClient = auth_client_1.AuthClient.getInstance(options);
    }
    handleOptions(options) {
        var _a;
        if (options.headers) {
            options.headers[sdk_contants_1.HEADERS_BE_TO_BE] =
                ((_a = this.authClient.getToken()) === null || _a === void 0 ? void 0 : _a.accessToken) || '';
        }
    }
    async handleAuthClient(error, options) {
        var _a;
        if (this.tokenRequest &&
            this.tokenRequest.clientId &&
            error.response.status === 401) {
            const token = await this.authClient.requestToken(this.tokenRequest);
            this.authClient.setToken(token);
            this.handleOptions(options);
            return true;
        }
        if (this.tokenRequest &&
            this.tokenRequest.clientId &&
            error.response.status === 400) {
            const errorExists = (error.response.body.errors || []).find((e) => {
                return (e.details.message === 'Token expired' ||
                    e.details.message === 'Missing token');
            });
            if (!errorExists)
                return false;
            let token;
            try {
                token = await this.authClient.refreshToken({
                    refreshToken: (_a = this.authClient.getToken()) === null || _a === void 0 ? void 0 : _a.refreshToken,
                });
            }
            catch (e) {
                token = await this.authClient.requestToken(this.tokenRequest);
            }
            this.authClient.setToken(token);
            this.handleOptions(options);
            return true;
        }
        return false;
    }
    async get(url, options) {
        this.handleOptions(options);
        try {
            return await super.get(url, options);
        }
        catch (e) {
            if (await this.handleAuthClient(e, options)) {
                return await super.get(url, options);
            }
        }
    }
    async delete(url, options) {
        this.handleOptions(options);
        try {
            return await super.delete(url, options);
        }
        catch (e) {
            if (await this.handleAuthClient(e, options)) {
                return await super.delete(url, options);
            }
        }
    }
    async head(url, options) {
        this.handleOptions(options);
        try {
            return await super.head(url, options);
        }
        catch (e) {
            if (await this.handleAuthClient(e, options)) {
                return await super.head(url, options);
            }
        }
    }
    async post(url, data, options) {
        this.handleOptions(options);
        try {
            return await super.post(url, data, options);
        }
        catch (e) {
            if (await this.handleAuthClient(e, options)) {
                return await super.post(url, data, options);
            }
        }
    }
    async put(url, data, options) {
        this.handleOptions(options);
        try {
            return await super.put(url, data, options);
        }
        catch (e) {
            if (await this.handleAuthClient(e, options)) {
                return await super.put(url, data, options);
            }
        }
    }
    async patch(url, data, options) {
        this.handleOptions(options);
        try {
            return await super.patch(url, data, options);
        }
        catch (e) {
            if (await this.handleAuthClient(e, options)) {
                return await super.patch(url, data, options);
            }
        }
    }
    getTokenRequest() {
        return this.tokenRequest;
    }
    getAuthClient() {
        return this.authClient;
    }
}
exports.DefaultHttpClient = DefaultHttpClient;
//# sourceMappingURL=default-http.client.js.map